/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SecurityAuthenticationInputAppCodeAliases {
  DIGIT_INPUTS_MFA_CODE = 'digitInputs-mfa-code',
  LAYOUT_MFA_AUTHENTICATION = 'layout-mfa-authentication',
  LOADER_MFA_AUTHENTICATION_CODE = 'loader-mfa-authentication-code',
  PANEL_LOADER_MFA_AUTHENTICATION = 'panel-loader-mfa-authentication',
  TEXT_MFA_INPUT_CODE = 'text-mfa-input-code',
}
export { SecurityAuthenticationInputAppCodeAliases };
